var _defs, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResCircMl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 710.1,
    height: 717.598,
    viewBox: "0 0 710.1 717.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.229,
    y1: 1.111,
    x2: 0.297,
    y2: -0.366,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0414ee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08caf2"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272,
    cy: 234,
    rx: 272,
    ry: 234,
    transform: "translate(353.204) rotate(49)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResCircMl);
export default __webpack_public_path__ + "static/media/res-circ-ml.76a2f220c09932448e89dd475f246346.svg";
export { ForwardRef as ReactComponent };